<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Voyage to the Land of Blue Mists</h1>
<ol class="toc">
<li id="toc-li-1">
<a href="#/text/ch001#about-the-author">About the Author</a>
</li>
<li id="toc-li-2">
<a href="#/text/ch002#dedication">Dedication</a>
</li>
<li id="toc-li-3">
<a href="#/text/ch003#copyright-information">Copyright Information ©</a>
</li>
<li id="toc-li-4">
<a href="#/text/ch004#acknowledgement">Acknowledgement</a>
</li>
<li id="toc-li-5">
<a href="#/text/ch005#world-map">World Map</a>
</li>
<li id="toc-li-6">
<a href="#/text/ch006#prologue">Prologue</a>
</li>
<li id="toc-li-7">
<a href="#/text/ch007#chapter-1">Chapter 1: <span style="font-style:italic; font-weight:normal;">Discovery</span></a>
<ol class="toc">
<li id="toc-li-8">
<a href="#/text/ch007#discovery"></a>
</li>
</ol>
</li>
<li id="toc-li-9">
<a href="#/text/ch008#chapter-2">Chapter 2: <span style="font-style:italic; font-weight:normal;">The Ship’s Crew</span></a>
<ol class="toc">
<li id="toc-li-10">
<a href="#/text/ch008#the-ships-crew"></a>
</li>
</ol>
</li>
<li id="toc-li-11">
<a href="#/text/ch009#chapter-3">Chapter 3: <span style="font-style:italic; font-weight:normal;">Commerce</span></a>
<ol class="toc">
<li id="toc-li-12">
<a href="#/text/ch009#commerce"></a>
</li>
</ol>
</li>
<li id="toc-li-13">
<span href="#/text/ch010#chapter-4" title="Link target outside of Sample">Chapter 4: <span style="font-style:italic; font-weight:normal;">The Commission</span></span>
<ol class="toc">
<li id="toc-li-14">
<span href="#/text/ch010#the-commission" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-15">
<span href="#/text/ch011#chapter-5" title="Link target outside of Sample">Chapter 5: <span style="font-style:italic; font-weight:normal;">Conversion</span></span>
<ol class="toc">
<li id="toc-li-16">
<span href="#/text/ch011#conversion" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-17">
<span href="#/text/ch012#chapter-6" title="Link target outside of Sample">Chapter 6: <span style="font-style:italic; font-weight:normal;">The Race</span></span>
<ol class="toc">
<li id="toc-li-18">
<span href="#/text/ch012#the-race" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-19">
<span href="#/text/ch013#chapter-7" title="Link target outside of Sample">Chapter 7: <span style="font-style:italic; font-weight:normal;">Confrontation</span></span>
<ol class="toc">
<li id="toc-li-20">
<span href="#/text/ch013#confrontation" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-21">
<span href="#/text/ch014#chapter-8" title="Link target outside of Sample">Chapter 8: <span style="font-style:italic; font-weight:normal;">The Rescue</span></span>
<ol class="toc">
<li id="toc-li-22">
<span href="#/text/ch014#the-rescue" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-23">
<span href="#/text/ch015#chapter-9" title="Link target outside of Sample">Chapter 9: <span style="font-style:italic; font-weight:normal;">Famine</span></span>
<ol class="toc">
<li id="toc-li-24">
<span href="#/text/ch015#famine" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-25">
<span href="#/text/ch016#chapter-10" title="Link target outside of Sample">Chapter 10: <span style="font-weight:normal; font-style:italic;">The Wreck</span></span>
<ol class="toc">
<li id="toc-li-26">
<span href="#/text/ch016#the-wreck" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-27">
<span href="#/text/ch017#chapter-11" title="Link target outside of Sample">Chapter 11: <span style="font-weight:normal; font-style:italic;">Civil War on Land</span></span>
<ol class="toc">
<li id="toc-li-28">
<span href="#/text/ch017#civil-war-on-land" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-29">
<span href="#/text/ch018#chapter-12" title="Link target outside of Sample">Chapter 12: <span style="font-weight:normal; font-style:italic;">Civil War at Sea</span></span>
<ol class="toc">
<li id="toc-li-30">
<span href="#/text/ch018#civil-war-at-sea" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-31">
<span href="#/text/ch019#chapter-13" title="Link target outside of Sample">Chapter 13: <span style="font-weight:normal; font-style:italic;">The Traitor Part 1</span></span>
<ol class="toc">
<li id="toc-li-32">
<span href="#/text/ch019#the-traitor-part-1" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-33">
<span href="#/text/ch020#chapter-14" title="Link target outside of Sample">Chapter 14: <span style="font-weight:normal; font-style:italic;">The Traitor Part 2</span></span>
<ol class="toc">
<li id="toc-li-34">
<span href="#/text/ch020#the-traitor-part-2" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-35">
<span href="#/text/ch021#chapter-15" title="Link target outside of Sample">Chapter 15: <span style="font-weight:normal; font-style:italic;">The Temple</span></span>
<ol class="toc">
<li id="toc-li-36">
<span href="#/text/ch021#the-temple" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-37">
<span href="#/text/ch022#chapter-16" title="Link target outside of Sample">Chapter 16: <span style="font-weight:normal; font-style:italic;">The Land of Blue Mists</span></span>
<ol class="toc">
<li id="toc-li-38">
<span href="#/text/ch022#the-land-of-blue-mists" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-39">
<span href="#/text/ch023#chapter-17" title="Link target outside of Sample">Chapter 17: <span style="font-weight:normal; font-style:italic;">Expulsion</span></span>
<ol class="toc">
<li id="toc-li-40">
<span href="#/text/ch023#expulsion" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-41">
<span href="#/text/ch024#chapter-18" title="Link target outside of Sample">Chapter 18: <span style="font-weight:normal; font-style:italic;">The Search Is Over</span></span>
<ol class="toc">
<li id="toc-li-42">
<span href="#/text/ch024#the-search-is-over" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-43">
<span href="#/text/ch025#chapter-19" title="Link target outside of Sample">Chapter 19: <span style="font-weight:normal; font-style:italic;">The Return Home</span></span>
<ol class="toc">
<li id="toc-li-44">
<span href="#/text/ch025#the-return-home" title="Link target outside of Sample"></span>
</li>
</ol>
</li>
<li id="toc-li-45">
<span href="#/text/ch026#epilogue" title="Link target outside of Sample">Epilogue</span>
</li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?f5ad3ac2